<template>
  <div>
    <image-gallery v-if='!singleUpload && showUploadedImages'
                   :images='uploadedImages'
                   :horizontal-mode='true'
                   @select='onSelectAsset' />
    <p v-if='waitingUpload > 0' class="status-message">
      Uploading...
    </p>
    <p v-else-if='waitingProcess > 0' class="status-message">
      <loading>
        <p class="text-black text-lg font-semibold">Processing upload(s)...</p>
        <p class="text-black mb-2">This may take up to a minute, especially for videos or GIFs.</p>
        <p class="text-gray-700 text-xs">You can upload images, videos or GIFs. Some larger GIFs may fail to import. Try smaller versions instead.</p>
      </loading>
      Processing...
      <span class="bg-orange-300 text-black rounded p-1">
        {{waitingProcess}}
      </span>
    </p>

    <!--
    <h3 v-if='myUploadedImages.length' class="bg-gray-100 px-4 mb-3 text-3xl font-bold text-gray-600 shadow leading-relaxed tracking-wide border-b border-solid border-gray-500">
      My Library
    </h3>
    <image-gallery v-if='myUploadedImages.length'
                   :images='myUploadedImages'
                   v-on='$listeners' />
      -->

      <h3 v-if='!singleUpload && showUploadedImages' class="px-4 mb-3 text-lg font-bold text-gray-600 shadow leading-relaxed tracking-wide">
      Uploaded
    </h3>

    <vue-dropzone ref='dropzone'
                  :id="dropzoneId"
                  :options="dropzoneOptions"
                  :use-custom-slot="true"
                  @click.self='onRetry'
                  @vdropzone-processing='onProcessing'
                  @vdropzone-error='onError'
                  @vdropzone-removed-file='onRemovedFile'
                  @vdropzone-success='onSuccess'
                  >
                  <slot name="default" :waiting-process='waitingProcess' :waiting-upload='waitingUpload'>
                  <div class="dropzone-custom-content bg-blue-600">
                    <h3 v-if='!isShortMode' class="text-lg font-semibold text-white text-lg p-4">Tap here to upload an image!</h3>
                    <div v-if='!isShortMode' class="text-sm leading-tight text-gray-200">...or drag and drop an image into the box.</div>
                    <p v-if='!isShortMode' class="mb-3 font-bold text-xs font-thin text-orange-800">This is a public gallery.</p>

                    <h3 v-if='isShortMode' class="text-sm font-semibold text-white text-lg p-4">Tap here to upload an image!</h3>
                  </div>
                  </slot>
    </vue-dropzone>
    <div v-if='isError' class="-my-8">
      <div class="flex justify-center align-middle w-full">
        <!--
        <pbc-button @click='onRetry'>
          Retry
        </pbc-button>
        -->
        <pbc-button @click='onReset'>
          Reset
        </pbc-button>
      </div>
    </div>


    <loading v-if='waitingSigning > 0' />

    <pbc-error v-if='errorMessage'
               @close='errorMessage = ""'
               :message="errorMessage" />
      <!--
    <pbc-popup v-if='errorMessage' @close='errorMessage = ""'>
      <p class="p-3">{{errorMessage}}</p>
    </pbc-popup>
      -->

  </div>
</template>
<script>
import ImportHelper from '@/ui/importhelper.js';
import { cloneDeep } from 'lodash';
import Loading from '@ui/atoms/Loading.vue';
import gql from 'graphql-tag';
import vueDropzone from 'nuxt-dropzone';
import ImageGallery from '@ui/molecules/ImageGallery.vue';
export default {
  inject:['api'],
  props: {
    gameId: {
      type: String,
      default: 'default',
    },
    // images uploaded for this game already
    alreadyUploaded: {
      type: Array,
      default() {
        return [];
      }
    },
    userId: {
      type: String,
      default: 'anonymous'
    },
    isShortMode: {
      type: Boolean,
      default: false
    },
    singleUpload: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  },
  data() {
    const vm = this;
    const dropzoneOptions = {
      // The URL will be changed for each new file being processing
      url: '/',

      //acceptedFiles: ['image/webp', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif'].join(","),

      headers:{
        'Cache-Control':'public,max-age=31536000'
      },

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      thumbnailWidth: 80,
      thumbnailHeight: 80,

      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      success: (file, bla) => {
        console.log('UPLOAD SUCCESS', file, bla);
        const {uploadURL} = file;
        const fileMetadata = this.metadata[uploadURL];
        console.log('filemetadata', fileMetadata);

        setTimeout( () => {
          this.$refs.dropzone.dropzone.removeFile(file);
        }, 100);
      },

      // Here we request a signed upload URL when a file being accepted
      async accept(file, done) {
        console.log('have file', file);
        vm.waitingUpload++;
        vm.waitingProcess++;
        vm.waitingSigning++;
        try {
          console.log('accept', file);
          const {url,id,name} = await vm.getSignedUrl(file.name, file.type);
          const userId = vm.userId;
          vm.waitingSigning--;
          file.uploadURL = url
          vm.metadata[url] = {
            id,
            name,
            owner:userId
          }
          done()
          setTimeout(() => this.processFile(file))


        } catch (e) {
          vm.waitingSigning--;
          vm.waitingUpload--;
          console.error('failed getting signed url', e);
          done("Failed");
        }
      }
    }
    const importHelper = new ImportHelper(this.api, this.$apollo);
    return {
      importHelper,
      isError:false,
      isSuccess:false,
      busyUploading: false,
      uploadedFiles:cloneDeep(this.alreadyUploaded),
      metadata:{},
      errors:[],
      waitingSigning:0,
      waitingUpload:0,
      waitingProcess:0,
      dropzoneOptions,
      batch:new Date().getTime(),
      errorMessage:'',
      getSignedUrlMutation: gql(`
        mutation getSignedImageUploadUrl(
          $filename: String!
          $contentType: String!
          $gameId: String!,
          $batch: Long
        ) {
          getSignedImageUploadUrl(
            filename: $filename
            contentType: $contentType
            gameId: $gameId,
            batch: $batch
          ) {
            id
            name
            url
          }
        }
      `)
    }
  },
  methods: {
    onSelectAsset({asset}) {
      this.$emit('select', asset);
    },
    onSuccess(file) {
      this.isSuccess = true;
      console.log('success', file);
      this.waitingUpload--;

      this.waitForProcessing(file);

    },
    onError(file) {
      console.error('error', file);
      this.isError = true;
      this.errors.push(file);
    },
    onRetry() {
      this.isError = false;
      this.isSuccess = false;
      this.errors.forEach( (file) => {
        this.$refs.dropzone.dropzone.removeFile(file);
        this.$refs.dropzone.dropzone.enqueueFile(file);
      });
      this.errors = [];
    },
    onReset() {
      this.isError = false;
      this.isSuccess = false;
      this.errors = [];
      this.$refs.dropzone.removeAllFiles();
    },
    onRemovedFile(file) {
    },
    onProcessing(file) {
      this.$refs.dropzone.dropzone.options.url = file.uploadURL;
      this.dropzoneOptions.url = file.uploadURL;
    },
    async waitForProcessing(uploadedFile) {

      const file = this.metadata[uploadedFile.uploadURL];
      const id = file.id;

      let waitingData = {};
      try {
        console.log('waiting for import of', id);
        waitingData = await this.importHelper.waitForUpload(id);
        console.log('have import data', waitingData);
      } catch (e) {
        console.error('lol', e);
        this.waitingProcess--;
        this.errorMessage = `Oops! Cannot process file. ${uploadedFile.name}.\nSupported types: png/jpg/gif/mp4/gif/webp. Maybe try a smaller file?`;
        return;
      }
      this.waitingProcess--;

      console.log('waitingData', waitingData);
      if (waitingData.__type === 'image') {
        const asset = {
          __type: 'image',
          ...file
        }
        this.uploadedFiles.push(asset);
        this.$emit("uploaded", asset);
        if (this.waitingProcess === 0) {
          if (this.singleUpload) {
            this.$emit('select', this.uploadedImages[this.uploadedImages.length-1].asset);
          }
        }
      } else if (waitingData.__type === 'animation') {
        const asset = waitingData;
        this.uploadedFiles.push(asset);
        this.$emit("uploaded", asset);
        if (this.waitingProcess === 0) {
          if (this.singleUpload) {
            this.$emit('select', this.uploadedImages[this.uploadedImages.length-1].asset);
          }
        }
      } else {
        console.error('what kind of import is', waitingData);
      }

    },
    async getSignedUrl(filename, contentType) {
      console.log('signing', filename, 'with', contentType);
      const {gameId, batch} = this;
      const data = await this.$apollo.mutate({
        mutation:this.getSignedUrlMutation,
        variables: {
          filename,
          contentType,
          gameId,
          batch
        }
      });
      console.log('have signed url data', data);
      return data.data.getSignedImageUploadUrl;
    },
  },
  beforeDestroy() {
    this.destroyed = true;
  },
  components: {
    vueDropzone,
    ImageGallery,
    Loading
  },
  computed: {
    isUploading() {
      return this.waitingProcess > 0 || this.waitingUpload > 0;
    },
    showUploadedImages() {
      return this.uploadedImages.length && !this.isUploading;
    },
    dropzoneId() {
      return this.gameId + "-dropzone";
    },
    /*
    uploadedAssets() {
      return this.uploadedFiles;
    },
    */

    uploadedImages() {
      return this.uploadedFiles.map( (asset) => {
        const {id, name, owner, __type} = asset;
        if (__type === 'image') {
          let url;
          if (asset.url) {
            url = asset.url;
          } else {
            url = this.api.makeImageUrlEditor(id);
          }
          return {
            url,
            name,
            id,
            owner,
            asset
          }
        } else if (__type === 'animation') {
          let url = this.api.makeAnimationThumbnailUrl(asset.thumbnail);
          return {
            url,
            name,
            id,
            owner,
            asset
          }
        }
      });
    },
    myUploadedImages() {
      return this.uploadedImages.filter( ({owner}) => {
        return owner === this.userId;
      });
    },
  }
}
</script>
<style>
.vue-dropzone {
  border: none !important;
}
.dropzone {
  background-color: initial !important;
  padding: 0px !important;
  min-height: auto !important;
}
.dropzone .dz-message {
  margin: 0px !important;
}
.status-message {
  @apply bg-gray-100 px-1 mb-1 text-lg font-bold text-gray-700 shadow leading-relaxed tracking-wide border-b border-solid border-gray-500
}
</style>

